import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";

const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api`;

const apiCall = async (promise, rejectWithValue, validate = false) => {
  try {
    const response = await trackPromise(promise);
    if (validate) {
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
    }
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
};

export const postBaseAndHeatFactorFilterApi = createAsyncThunk(
  "baseAndHeatFactor/postBaseAndHeatFactorFilterApi",
  async (accountNumbers, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.post(`${baseUrl}/Marketer/report/base-and-heat-factor/filter`, {
        Data: { accountNumbers },
      }),
      rejectWithValue,
      true
    )
);
